import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

/**
 * Rejects a date that is after today. Empty values are valid (combine with
 * Validators.required when the field is mandatory). Today is allowed.
 *
 * Error key: `futureDate`.
 */
export function notFutureDate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (value === null || value === undefined || value === '') return null;

        let year: number;
        let month: number;
        let day: number;
        if (typeof value === 'string') {
            // Read the calendar day as written, avoiding the UTC shift of new Date('YYYY-MM-DD').
            const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
            if (match) {
                year = +match[1];
                month = +match[2] - 1;
                day = +match[3];
            } else {
                const parsed = new Date(value);
                if (isNaN(parsed.getTime())) return null;
                year = parsed.getFullYear();
                month = parsed.getMonth();
                day = parsed.getDate();
            }
        } else {
            const parsed = value instanceof Date ? value : new Date(value);
            if (isNaN(parsed.getTime())) return null;
            year = parsed.getFullYear();
            month = parsed.getMonth();
            day = parsed.getDate();
        }

        const today = new Date();
        const selected = new Date(year, month, day).getTime();
        const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
        return selected > todayStart ? {futureDate: true} : null;
    };
}
